module.exports = __webpack_public_path__ + "img/horizontal_7_3_pp3_6005.5df61657.png";